import { Error } from "components/icons/Error";
import { InfoFilled } from "components/icons/InfoFilled";
import { LoadingIcon } from "components/icons/LoadingIcon";
import { SolidCheck } from "components/icons/SolidCheck";
import { Warning } from "components/icons/Warning";
import { Toaster as SonnerToaster, type ToasterProps } from "sonner";
import { Cross } from "components/icons/Cross";

export const Toaster = ({
  position = "bottom-right",
  ...rest
}: ToasterProps) => {
  return (
    <SonnerToaster
      position={position}
      className="!t-z-toast"
      closeButton
      toastOptions={{
        unstyled: true,
        classNames: {
          /* @tw */
          icon: "t-flex t-relative group-has-[.sonner-loader[data-visible='true']]:t-mx-1.5 t-justify-start t-items-start",
          /* @tw */
          toast:
            "t-group t-flex t-min-w-[300px] t-max-w-[20.5rem] t-items-start t-gap-2 t-rounded-md t-border t-border-solid t-border-text-60 t-bg-text-100 t-p-3 t-shadow-lg",
          /* @tw */
          title: "t-text-subtext-sm t-text-surface t-max-w-48",
          /* @tw */
          description: "t-text-body-sm t-text-neutral-30",
          /* @tw */
          actionButton:
            "all:unset t-text-subtext-sm t-text-purple-40 hover:t-text-purple-30 t-absolute t-right-10",
          /* @tw */
          closeButton: "all:unset t-absolute t-right-3",
          /* @tw */
          loader: "t-absolute !t-top-2",
        },
      }}
      icons={{
        success: (
          <span className="t-text-green t-shrink-0 t-flex t-justify-start t-items-start t-mt-0.5">
            <SolidCheck size="16" color="currentColor" />
          </span>
        ),
        info: (
          <span className="t-text-blue-50 t-shrink-0 t-flex t-justify-start t-items-start t-mt-0.5">
            <InfoFilled size="16" />
          </span>
        ),
        warning: (
          <span className="t-text-orange-50 t-shrink-0 t-flex t-justify-start t-items-start t-mt-0.5">
            <Warning size="16" color="currentColor" />
          </span>
        ),
        error: (
          <span className="t-text-red-50 t-shrink-0 t-flex t-justify-start t-items-start t-mt-0.5">
            <Error size="16" />
          </span>
        ),
        loading: (
          <span className="t-flex t-animate-spin t-text-surface t-shrink-0">
            <LoadingIcon />
          </span>
        ),
        close: (
          <span className="t-text-neutral-40 hover:t-text-neutral-10">
            <Cross color="currentColor" />
          </span>
        ),
      }}
      {...rest}
    />
  );
};
